import { VerificationDisplayCard } from "../verification-display-card";
import { VerificationDisplayCardWide } from "../verification-display-card-wide";
import { verificationData } from "../../data/verification-data";
import "./verification-features.css";

export function VerificationFeatures() {
  return (
    <section className="r2-verification-features">
      <div className="r2-verification-features__grid">
        {verificationData.map((item, idx) => {
          if (idx === 2)
            return (
              <div
                key={item.heading}
                className="r2-verification-features__item r2-verification-features__item--wide"
              >
                <VerificationDisplayCardWide
                  heading={item.heading}
                  subHeading={item.subHeading}
                  img={item.img}
                  link={item.link}
                  gradientBottom={item?.gradientBottom ?? false}
                  verificationBlips={item.verificationBlips}
                />
              </div>
            );

          return (
            <div key={item.heading} className="r2-verification-features__item">
              <VerificationDisplayCard
                heading={item.heading}
                subHeading={item.subHeading}
                img={item.img}
                link={item.link}
                gradientBottom={item?.gradientBottom ?? false}
                verificationBlips={item.verificationBlips}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
